/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import './src/styles/global.css';
import './src/styles/custom.css';
import './src/styles/blobz.min.css';
import React, { ReactNode } from 'react';
import { RootProvider, PageProvider } from '@src/common/ui/Providers';
import { initializeSentry } from '@src/util/initSentry';
import { initPostHog, isPostHogEnabled, posthog } from '@src/lib/posthog';
import { initBetterStack } from '@src/lib/betterstack';

initializeSentry();
initPostHog();
initBetterStack();

export const wrapRootElement = ({ element }: { element: ReactNode }) => (
    <RootProvider isSSR={false}>
        {element}
    </RootProvider>
);

export const wrapPageElement = ({ element }: { element: ReactNode }) => (
    <PageProvider isSSR={false}>
        {element}
    </PageProvider>
);

// Track SPA page views (only when PostHog is initialized and not disabled)
export const onRouteUpdate = ({ location }: { location: Location }) => {
    if (typeof window !== 'undefined' && isPostHogEnabled()) {
        posthog.capture('$pageview', {
            $current_url: location.href,
            path: location.pathname,
        });
    }
};

// Prevent page scrolling on url search parameters change
export const shouldUpdateScroll = () => {
    return false;
};
